export const SITE = {
  name: "Cytocare Formulations Pvt. Ltd.",
  shortName: "Cytocare",
  tagline: "Caring Life and Beyond...",
  founded: 2007,
  email: "info@cytocare.in",
  website: "www.cytocare.in",
};

export const PILLARS = [
  {
    title: "Uncompromising Quality",
    desc: "Every formulation meets rigorous standards to ensure safety and efficacy — manufactured in tie-up with world-class leading facilities.",
  },
  {
    title: "Accessible Pricing",
    desc: "We bridge the gap between high-end medical breakthroughs and affordability, so life-saving molecules reach every segment of society.",
  },
  {
    title: "Ethical Marketing",
    desc: "Our growth is driven by integrity and a commitment to transparent, patient-centric healthcare practices.",
  },
];

export const CATEGORIES = [
  "All",
  "Oncology",
  "Gastroenterology",
  "Antibiotics",
  "Nutraceuticals & Supportive Care",
];

export const PRODUCTS = [
  {
    id: "paclisafe",
    brand: "PACLISAFE",
    composition: "Paclitaxel Injection",
    category: "Oncology",
    form: "Antineoplastic Injection",
    desc: "Trusted taxane chemotherapy for ovarian, breast and lung malignancies.",
  },
  {
    id: "coloplat",
    brand: "COLOPLAT",
    composition: "Oxaliplatin Injection",
    category: "Oncology",
    form: "Antineoplastic Injection",
    desc: "Platinum-based therapy, a cornerstone in colorectal cancer regimens.",
  },
  {
    id: "gemce",
    brand: "GEMCE",
    composition: "Gemcitabine Injection",
    category: "Oncology",
    form: "Antineoplastic Injection",
    desc: "Antimetabolite chemotherapy used across pancreatic, lung and bladder cancers.",
  },
  {
    id: "cytofil",
    brand: "CYTOFIL",
    composition: "Filgrastim Injection (G-CSF)",
    category: "Oncology",
    form: "Supportive Care Injection",
    desc: "Stimulates white blood cell recovery during chemotherapy-induced neutropenia.",
  },
  {
    id: "docecare",
    brand: "DOCECARE",
    composition: "Docetaxel Injection",
    category: "Oncology",
    form: "Antineoplastic Injection",
    desc: "Taxane chemotherapy for breast, prostate, lung and gastric cancers.",
  },
  {
    id: "pemsafe",
    brand: "PEMSAFE",
    composition: "Pemetrexed Injection",
    category: "Oncology",
    form: "Antineoplastic Injection",
    desc: "Antifolate therapy for non-small cell lung cancer and mesothelioma.",
  },
  {
    id: "cytocap",
    brand: "CYTOCAP",
    composition: "Capecitabine Tablets",
    category: "Oncology",
    form: "Oral Antineoplastic",
    desc: "Oral fluoropyrimidine for colorectal and breast cancer therapy.",
  },
  {
    id: "cytoprotein",
    brand: "CYTOPROTEIN",
    composition: "Whey Protein with Vitamins & Minerals",
    category: "Nutraceuticals & Supportive Care",
    form: "Powder · 200g",
    image: "/assets/products/page-2.jpg",
    tagline: "Caring Your Nutrition & Beyond...",
    benefits: [
      "Improves nutritional status & provides essential amino acids",
      "Reduces muscle loss and recovery time in surgery",
      "Effective in tissue formation & prevents malnutrition",
    ],
  },
  {
    id: "cytocumin",
    brand: "CYTOCUMIN",
    composition: "Nano Curcumin 150mg, Lycopene 25mg & Piperine 5mg",
    category: "Nutraceuticals & Supportive Care",
    form: "Capsules",
    image: "/assets/products/page-3.jpg",
    tagline: "Scavenging Free Radicals & Beyond...",
    benefits: [
      "Natural antioxidant & anti-inflammatory action",
      "Piperine enhances curcumin absorption",
      "Supportive role in cardiovascular & neurological health",
    ],
  },
  {
    id: "uriglim",
    brand: "URIGLIM",
    composition: "Ursodeoxycholic Acid 300mg",
    category: "Gastroenterology",
    form: "Tablets",
    image: "/assets/products/page-4.jpg",
    tagline: "Caring Liver & Beyond...",
    benefits: [
      "Trusted treatment for recovery of liver damage",
      "Supports healthy bile flow and liver function",
    ],
  },
  {
    id: "cytoboost",
    brand: "CYTOBOOST",
    composition: "Colostrum 200mg & Beta Glucan 200mg",
    category: "Nutraceuticals & Supportive Care",
    form: "Capsules",
    image: "/assets/products/page-5.jpg",
    tagline: "Caring Immunity & Beyond...",
    benefits: [
      "Boosts the body against frequent infections",
      "Beta Glucan stimulates the immune system",
      "Rich in immunoglobulins & lactoferrins",
    ],
  },
  {
    id: "cytojoy",
    brand: "CYTOJOY",
    composition: "L-Ornithine L-Aspartate 250mg, Silymarin 140mg with B-Vitamins",
    category: "Gastroenterology",
    form: "Capsules",
    image: "/assets/products/page-6.jpg",
    tagline: "Caring Liver & Beyond...",
    benefits: [
      "Gives the liver the joy of revival",
      "Supports detoxification and hepatic regeneration",
    ],
  },
  {
    id: "cytolid",
    brand: "CYTOLID",
    composition: "Linezolid 600mg",
    category: "Antibiotics",
    form: "Tablets",
    image: "/assets/products/page-7.jpg",
    tagline: "Caring Infections & Beyond...",
    benefits: [
      "Effective treatment for Gram-positive infections",
      "Active against MRSA & VRE infections",
      "Covers skin, soft tissue, bone & joint infections",
    ],
  },
  {
    id: "gasolock",
    brand: "GASOLOCK",
    composition: "Esomeprazole 40mg",
    category: "Gastroenterology",
    form: "Capsules",
    image: "/assets/products/page-8.jpg",
    tagline: "Caring Stomach & Beyond...",
    benefits: [
      "Best-in-class proton pump inhibitor",
      "Rapid relief from heartburn & acid reflux",
    ],
  },
  {
    id: "gasolock-dsr",
    brand: "GASOLOCK-DSR",
    composition: "Esomeprazole 40mg & Domperidone 30mg",
    category: "Gastroenterology",
    form: "Capsules",
    image: "/assets/products/page-9.jpg",
    tagline: "Caring Stomach & Beyond...",
    benefits: [
      "PPI combined with the best prokinetic agent",
      "Effective against GERD, dyspepsia & peptic ulcer",
      "Aids digestion and reduces nausea",
    ],
  },
  {
    id: "isoloose",
    brand: "ISOLOOSE",
    composition: "Lactulose Solution USP 10g/15ml",
    category: "Gastroenterology",
    form: "Syrup · 200ml",
    image: "/assets/products/page-10.jpg",
    tagline: "Caring Gut & Beyond...",
    benefits: [
      "Effective and safe laxative",
      "Treats chronic constipation & hepatic encephalopathy",
      "Safe and non-addictive in nature",
    ],
  },
];

export const THERAPIES = [
  {
    name: "Oncology",
    focus: "Branded antineoplastic molecules — the foundation of Cytocare and a first in Eastern India.",
    molecules: "PACLISAFE · COLOPLAT · GEMCE · DOCECARE · PEMSAFE · CYTOCAP",
  },
  {
    name: "Gastroenterology",
    focus: "Complete gut and liver care — from acid peptic disorders to hepatic support and laxatives.",
    molecules: "GASOLOCK · GASOLOCK-DSR · ISOLOOSE · URIGLIM · CYTOJOY",
  },
  {
    name: "Antibiotics",
    focus: "Injectable and oral antibiotics for serious Gram-positive and hospital-acquired infections.",
    molecules: "CYTOLID",
  },
  {
    name: "Neuropsychiatry",
    focus: "Expanding support for neurological and psychiatric wellbeing with specialised formulations.",
    molecules: "Growing portfolio",
  },
  {
    name: "Cardio-Diabetic",
    focus: "Chronic care formulations for cardiovascular and diabetic patients, built for long-term therapy.",
    molecules: "Growing portfolio",
  },
  {
    name: "Nutraceuticals & Supportive Care",
    focus: "Nutrition, immunity and antioxidant support that complements active treatment and recovery.",
    molecules: "CYTOPROTEIN · CYTOCUMIN · CYTOBOOST",
  },
  {
    name: "Geriatric & Palliative Care",
    focus: "Compassionate formulations focused on comfort, dignity and quality of life.",
    molecules: "Emerging segment",
  },
];
